import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/auto-assign')({
    component: AutoAssignRedirect,
});

// Auto assign moved into the consolidated Scheduling page.
function AutoAssignRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
